import React, { useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Roadmap } from 'shared/assets/icons';
import { Button, Colors, Sizes, Variants } from 'shared/components/ui/button';
import { EmptyState } from 'shared/components/ui/empty-state';
import { PopupMenu } from 'shared/components/ui/popup-menu';
import { ID } from 'shared/types/id';

import { LifeAreaRoadmapAddMenu } from '../life-area-roadmap-add-menu';

// Roadmap items are top-level in the life area, so they have no parent goal.
const NO_PARENT_IDS: ID[] = [];

type LifeAreaRoadmapEmptyStateProps = {
  lifeAreaId: ID;
};

export const LifeAreaRoadmapEmptyState: React.FC<
  LifeAreaRoadmapEmptyStateProps
> = ({ lifeAreaId }) => {
  const { t } = useTranslation();
  const addButtonRef = useRef<HTMLButtonElement>(null);
  const [isAddMenuOpen, setIsAddMenuOpen] = useState(false);

  const handleOpenAddMenu = () => setIsAddMenuOpen(true);
  const handleCloseAddMenu = () => setIsAddMenuOpen(false);

  return (
    <EmptyState
      icon={Roadmap}
      title={t('life-area-detail.roadmap-preview.empty.title')}
      description={t('life-area-detail.roadmap-preview.empty.message')}
    >
      <Button
        ref={addButtonRef}
        variant={Variants.ContainedLight}
        color={Colors.Primary}
        size={Sizes.Small}
        onClick={handleOpenAddMenu}
      >
        {t('life-area-detail.roadmap-preview.empty.action')}
      </Button>
      {isAddMenuOpen && (
        <PopupMenu
          referenceElement={addButtonRef}
          onOutside={handleCloseAddMenu}
          position="bottom-start"
        >
          <LifeAreaRoadmapAddMenu
            parentIds={NO_PARENT_IDS}
            lifeAreaId={lifeAreaId}
            onClose={handleCloseAddMenu}
          />
        </PopupMenu>
      )}
    </EmptyState>
  );
};
